import Home from '@atlassian/mpac-home';
import { useLocation } from '@atlassian/mpac-ui';
import React from 'react';
import { Redirect } from 'react-router-dom';

import type { RouteComponentProps } from 'react-router-dom';

const productHomePageRedirectionMap = {
  jira: 'jira',
  confluence: 'confluence',
  'jira-service-management': 'jira-service-management',
  bitbucket: 'bitbucket',
  compass: 'compass',
  'fisheye-crucible': 'fisheye',
  bamboo: 'bamboo',
  crowd: 'crowd',
} as const;

const sortOptionsMap = {
  'top-rated': 'topRated',
  'top-selling': 'topSelling',
  trending: 'trending',
  newest: 'newest',
} as const;

type TParams = {
  app?: 'app' | 'cloud-fortified';
  appId?: string;
  productId?: string;
  sortBy?: string;
};

const AddonHomePageRouteProcessor = (props: RouteComponentProps<TParams>) => {
  const {
    match: { params },
  } = props;
  const { search } = useLocation();
  const param = new URLSearchParams(search);

  // for cases: /addons/app/:appId
  if (params.app === 'app' && params.appId && productHomePageRedirectionMap[params.appId]) {
    // for cases: /addons/app/:appId/:sortBy
    if (params.sortBy && sortOptionsMap[params.sortBy]) {
      return (
        <Redirect
          to={`/search?product=${productHomePageRedirectionMap[params.appId]}&sort=${
            sortOptionsMap[params.sortBy]
          }${search ? `&${param}` : ''}`}
        />
      );
    }
    return <Redirect to={`/product/${productHomePageRedirectionMap[params.appId]}`} />;
  }

  // for cases: /addons/app
  if (params.app === 'app') {
    return <Redirect to="/" />;
  }

  // for cases: /addons/cloud-fortified
  if (params.app === 'cloud-fortified') {
    return <Redirect to="/search?trustSignals=cloudFortified" />;
  }

  // for cases: /addons/trending
  if (params.app && sortOptionsMap[params.app]) {
    return <Redirect to={`/search?sort=${sortOptionsMap[params.app]}`} />;
  }

  return <Home productId={params.productId} />;
};

export default AddonHomePageRouteProcessor;
